<script>
  import Root from "./bits/calendar.svelte";

  import Day from "./calendar-day.svelte";
  import Grid from "./calendar-grid.svelte";
  import GridBody from "./calendar-grid-body.svelte";
  import Cell from "./calendar-cell.svelte";
  import GridHead from "./calendar-grid-head.svelte";
  import HeadCell from "./calendar-head-cell.svelte";
  import GridRow from "./calendar-grid-row.svelte";
  import Header from "./calendar-header.svelte";
  import Heading from "./calendar-heading.svelte";
  import Months from "./calendar-months.svelte";
  import NextButton from "./calendar-next-button.svelte";
  import PrevButton from "./calendar-prev-button.svelte";
  import * as Calendar from "./index.js";
  import {cn} from "../../utils.js";
  import {progress} from "../../data/progress/feature.progress.svelte.js";
  import * as booking_select_datetime from "../../data/booking/booking.scenarios.select.datetime.svelte.js";
  import {widgets} from "../../data/widgets/feature.widgets.svelte.js";
  import {booking} from "../../data/booking/feature.booking.svelte.js";
  import { ENTRY_TYPE_BADENKAART } from '../../AppConstants.js';

  () => {
    typeof Calendar
  }
  () => {
    typeof CalendarPrimitive
  }

  let {
        ref           = $bindable(null),
        value         = $bindable(),
        placeholder   = $bindable(),
        class: className,
        weekdayFormat = "short",
        type          = "single",
        placement     = "reserveerstraat", // reserveerstraat/widget
        ...restProps
      } = $props();

  let bCalendarHasPrices = $state(false);
  // console.log('snel testje 1A', Object.keys(progress.aCalendarDates).length, booking.sSelectedEntryType, $state.snapshot(progress.aCalendarDates));
  if ( progress.aCalendarDates && Object.keys(progress.aCalendarDates).length > 0 && booking.sSelectedEntryType !== ENTRY_TYPE_BADENKAART )
  {
    let oDayConfig;
    // console.log('snel testje 1A ALOHA');
    for ( const sDateKey in progress.aCalendarDates )
    {
      oDayConfig = progress.aCalendarDates[sDateKey];

      // console.log('snel testje 1B', oDayConfig);
      for ( const key in oDayConfig )
      {
        // console.log('snel testje 1C', key);
        if ( key.startsWith('p_') && oDayConfig[key] > 0 )
        {
          bCalendarHasPrices = true;
          break;
        }
      }
    }
  }

  /**
   * De toelichting bij één dag: de bestaande i.info-sleutel, of '' als die er niet is.
   * Bij een geblokkeerde dag staat daar het FrontendMessage in dat de beheerder in het CMS
   * heeft ingevuld; bij een volgeboekte of gesloten dag de tekst van de prijs-/infobouwer.
   */
  function getDayMessage(oDate)
  {
    const oDateConfig = progress.aCalendarDates[oDate.year + '-' + oDate.month + '-' + oDate.day];

    return oDateConfig?.i?.info || '';
  }

  /**
   * Toon de toelichting van een niet-boekbare dag ONDER de kalender (zie CalendarDayMessage).
   *
   * Dit hangt bewust aan de CEL (<td>) en niet aan de dag zelf: een niet-boekbare dag staat op
   * pointer-events: none (.hmk-day[data-disabled] in de gedeelde SCSS), dus die vangt geen klik,
   * tik of hover op. De cel eromheen doet dat wél. Selecteren blijft daardoor onmogelijk: de klik
   * bereikt de dag-handler van bits-ui niet eens, en die weigert een disabled dag sowieso.
   *
   * Een lege sMessage ruimt de melding op. Dat is precies wat we willen bij een boekbare dag:
   * tik je die aan, dan verdwijnt de toelichting van de dag die je daarvoor bekeek.
   */
  function showDayMessage(sMessage)
  {
    progress.sBlockedDayMessage = sMessage || false;
  }

  /**
   * Hover is alleen een muis-verhaal. Op touch vuurt pointerenter/pointerleave óók (rond de tik),
   * en dan zou de melding meteen weer verdwijnen voordat je hem gelezen hebt. Op touch laten we
   * de klik het werk doen en blijft de tekst staan tot de gast een andere dag aantikt.
   */
  function handleDayPointerEnter(oEvent, sMessage)
  {
    if ( oEvent.pointerType !== 'mouse' || !sMessage )
    {
      return;
    }

    showDayMessage(sMessage);
  }

  /**
   * Wissen gebeurt bewust op de KALENDER als geheel, niet per dagcel.
   *
   * Op celniveau vuurde pointerleave óók bij élke overgang tussen twee cellen: de haarlijn
   * tussen de cellen (de grid staat op justify-between met cellen van 14.2%) en de rijmarge
   * (mt-2) tellen allebei als "buiten de cel". De melding werd daardoor tussen twee dagen door
   * weggehaald en direct weer gezet - dát is het knipperen. En omdat de melding ONDER de
   * kalender staat, sprong de content eronder bij elke wissel mee.
   *
   * Op deze container vuurt pointerleave alleen als de muis de hele kalender verlaat; bewegen
   * binnen het raster (ook over de tussenruimtes) laat de tekst dus staan. Een andere dag
   * aanwijzen vervangt hem gewoon via handleDayPointerEnter.
   *
   * De muis-guard blijft nodig: op touch vuurt pointerleave rond het opheffen van de vinger,
   * en dan zou de melding verdwijnen voordat de gast hem gelezen heeft.
   */
  function handleCalendarPointerLeave(oEvent)
  {
    if ( oEvent.pointerType !== 'mouse' )
    {
      return;
    }

    showDayMessage('');
  }

</script>

<!--
Discriminated Unions + Destructing (required for bindable) do not
get along, so we shut typescript up by casting `value` to `never`.
-->

<Root
  bind:value
  bind:ref
  bind:placeholder
  {weekdayFormat}
  class={cn("p-3", className)}
  locale="nl"
  isDateUnavailable={(oDate) => {
    return false; // keuze.. of disabled of unavailble.. voor nu disabled
    // let sRequestedDate = oDate.year + '-' + oDate.month + '-' + oDate.day;
    //
    // if(typeof progress.aCalendarDates[sRequestedDate] === "undefined") {
    //   // we zitten buiten het bereik
    //   return true;
    // }
    //
    // let oCalendarConfigForDate = booking_select_datetime.getCalendarConfigForDate(sRequestedDate)
    //
    // return ! oCalendarConfigForDate.bIsEnabled;
  }}
  isDateDisabled={(oDate) => {
    //return false; // keuze.. of disabled of unavailble.. voor nu disabled
    let sRequestedDate = oDate.year + '-' + oDate.month + '-' + oDate.day;

    if(typeof progress.aCalendarDates[sRequestedDate] === "undefined") {
      // we zitten buiten het bereik
      return true;
    }

    let oCalendarConfigForDate = booking_select_datetime.getCalendarConfigForDate(sRequestedDate)

    if(!oCalendarConfigForDate) {
      return true;
    }

    return ! oCalendarConfigForDate.bIsEnabled;
  }}
  {...restProps}
>
  {#snippet children({months, weekdays})}
    <Header>
      <PrevButton/>
      <Heading/>
      <NextButton/>
    </Header>
    <!-- Wissen op kalenderniveau: zie handleCalendarPointerLeave. Per cel gaf dit geknipper. -->
    <Months onpointerleave={handleCalendarPointerLeave}>
      {#each months as month}
        <Grid>
          <GridHead>
            <GridRow class="flex justify-around align-center">
              {#each weekdays as weekday}
                <HeadCell>
                  {weekday.slice(0, 2).toUpperCase()}
                </HeadCell>
              {/each}
            </GridRow>
          </GridHead>
          <GridBody>
            {#each month.weeks as weekDates}
              <GridRow class="mt-2 w-full justify-between">
                {#each weekDates as date (date)}
                  {@const oCalendarDayConfig = booking_select_datetime.getCalendarConfigForDate(date)}
                  <!-- Alleen een NIET-boekbare dag krijgt een toelichting onder de kalender. Een
                       boekbare dag heeft zijn eigen HoverCard in de dag zelf; die werkt daar wél,
                       want die dag staat niet op pointer-events: none. -->
                  {@const sDayMessage = oCalendarDayConfig?.bIsEnabled === true ? '' : getDayMessage(date)}
                  {#if widgets.bIsThisAWidgetBuildInsteadOfTheShop === true}
                    <!-- widget -->
                    <Cell
                      {date}
                      month={month.value}
                      style="width: 13%;"
                      class={sDayMessage ? "cursor-help js-day-has-message" : ""}
                      onclick={() => showDayMessage(sDayMessage)}
                      onpointerenter={(oEvent) => handleDayPointerEnter(oEvent, sDayMessage)}
                    >
                      <Day
                        date={date}
                        selected_value={value}
                        oCalendarDayConfig={oCalendarDayConfig}
                        bCalendarHasPrices={bCalendarHasPrices}
                      />
                    </Cell>
                  {:else}
                    <!-- reserveerstraat -->
                    <Cell
                      {date}
                      month={month.value}
                      style="width: 14.2%;"
                      class={sDayMessage ? "cursor-help js-day-has-message" : ""}
                      onclick={() => showDayMessage(sDayMessage)}
                      onpointerenter={(oEvent) => handleDayPointerEnter(oEvent, sDayMessage)}
                    >
                      <Day
                        date={date}
                        selected_value={value}
                        oCalendarDayConfig={oCalendarDayConfig}
                        bCalendarHasPrices={bCalendarHasPrices}
                      />
                    </Cell>
                  {/if}
                {/each}
              </GridRow>
            {/each}
          </GridBody>
        </Grid>
      {/each}
    </Months>
  {/snippet}
</Root>
